import { Badge, Tooltip } from 'antd';
import { BellOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { ROUTE_REMINDERS } from '@/constants/routes';

type Props = {
  count: number;
};

export function ReminderBellBadge({ count }: Props) {
  const navigate = useNavigate();

  return (
    <Tooltip title={count > 0 ? `${count} 条未处理提醒` : '到期提醒'}>
      <Badge count={count} overflowCount={99} size="small">
        <BellOutlined
          style={{ fontSize: 18, cursor: 'pointer' }}
          onClick={() => navigate(ROUTE_REMINDERS)}
        />
      </Badge>
    </Tooltip>
  );
}
